var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "v-container",
                { staticClass: "ma-2 pa-2" },
                [
                  _c(
                    "div",
                    { staticClass: "overline mb-2" },
                    [
                      _c(
                        "v-row",
                        { staticClass: "mx-auto d-flex align-center overline" },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v(" mdi-format-list-checks ")
                          ]),
                          _c(
                            "p",
                            {
                              staticClass:
                                "font-weight-light caption pa-2 mx-0 my-0"
                            },
                            [_vm._v(" Descripción del permiso de acceso ")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "v-container",
                            {
                              staticClass: "text-center pa-2",
                              attrs: { flat: "" }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: { color: "var(--v-primaryGreen-base)" }
                                },
                                [_vm._v(" mdi-map-marker ")]
                              ),
                              _c(
                                "v-card-title",
                                {
                                  staticClass:
                                    "overline text-center justify-center"
                                },
                                [_vm._v("Data center")]
                              ),
                              _c("v-card-text", [
                                _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.ticketDetail.accessPermission
                                        .dataCenter.name
                                    )
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "v-container",
                            {
                              staticClass: "text-center pa-2",
                              attrs: { flat: "" }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    color: "var(--v-primaryDarkBlue-base)"
                                  }
                                },
                                [_vm._v(" mdi-calendar ")]
                              ),
                              _c(
                                "v-card-title",
                                {
                                  staticClass:
                                    "overline text-center justify-center"
                                },
                                [_vm._v("Fechas de acceso")]
                              ),
                              _c("v-card-text", { staticClass: "px-0" }, [
                                _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.setFormatDate(
                                          _vm.ticketDetail.accessPermission
                                            .startDate
                                        )
                                      ) +
                                      " "
                                  )
                                ]),
                                _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.setFormatDate(
                                          _vm.ticketDetail.accessPermission
                                            .endDate
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "v-container",
                            {
                              staticClass: "text-center pa-2",
                              attrs: { flat: "" }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    color: "var(--v-secondaryPurple-base)"
                                  }
                                },
                                [_vm._v(" mdi-login ")]
                              ),
                              _c(
                                "v-card-title",
                                {
                                  staticClass:
                                    "overline text-center justify-center"
                                },
                                [_vm._v("Motivos de acceso")]
                              ),
                              _c("v-card-text", [
                                _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getAccessMotives(
                                          _vm.ticketDetail.accessPermission
                                            .accessPermissionMotives
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c(
                            "v-container",
                            {
                              staticClass: "text-center pa-2",
                              attrs: { flat: "" }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    color: "var(--v-secondaryOrange-base)"
                                  }
                                },
                                [_vm._v(" mdi-account-arrow-right ")]
                              ),
                              _c(
                                "v-card-title",
                                {
                                  staticClass:
                                    "overline text-center justify-center"
                                },
                                [_vm._v("Razón de acceso")]
                              ),
                              _c("v-card-text", [
                                _c("div", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getAccessType(
                                          _vm.ticketDetail.accessPermission
                                            .accessPermissionMotives
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-container",
                { staticClass: "ma-2 pa-2", attrs: { flat: "" } },
                [
                  _c(
                    "div",
                    { staticClass: "overline mb-2" },
                    [
                      _c(
                        "v-row",
                        { staticClass: "mx-auto d-flex align-center overline" },
                        [
                          _c("v-icon", { attrs: { small: "" } }, [
                            _vm._v(" mdi-attachment ")
                          ]),
                          _c(
                            "p",
                            {
                              staticClass:
                                "font-weight-light caption pa-2 mx-0 my-0"
                            },
                            [_vm._v("Adjuntos")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mt-n2", attrs: { "no-gutters": "" } },
                    _vm._l(_vm.attachmentsToShow, function(i, k) {
                      return _c(
                        "v-col",
                        { key: k, attrs: { cols: "6" } },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass: "ma-2 text-center selectable",
                              attrs: { outlined: "", link: "" },
                              on: {
                                click: function($event) {
                                  return _vm.redirectTo(i.text)
                                }
                              }
                            },
                            [
                              _c(
                                "v-list-item",
                                { staticClass: "pa-3" },
                                [
                                  _c(
                                    "v-img",
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            "x-large": "",
                                            color: "blue"
                                          }
                                        },
                                        [_vm._v("mdi-file")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        { staticClass: "caption" },
                                        [_vm._v(_vm._s(i.text))]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item-action",
                                    { staticClass: "pa-0 ma-0" },
                                    [
                                      _vm.ticketDetail.accessPermission.status
                                        .id ===
                                        _vm.AWAITING_MODIFICATION_STATUS &&
                                      !_vm.IS_EMPLOYEE
                                        ? _c(
                                            "v-btn",
                                            { attrs: { icon: "" } },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { small: "" } },
                                                [_vm._v("mdi-pencil")]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }